
import {Vue, Component} from 'vue-property-decorator';

@Component
export default class PopUpAdNoticeMixin extends Vue {
	protected showsOauthTypeNotice = false;
	
	protected registerClickEvent() {
		const oauthTypeButton = this.$el.querySelector('.oauth_type_button');
		oauthTypeButton?.addEventListener('click', () => (this.showsOauthTypeNotice = true));
	}
	
	protected close(target) {
		this[target] = false;
	}
	
	mounted() {
		this.$el && this.registerClickEvent();
	}
}
